// extracted by mini-css-extract-plugin
export var columnList = "_bw-0";